// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./anchor-lines-container\"></require>\n  <anchor-lines-container if.bind=\"data.productionOrderId > 0\" production-order-id.bind=\"data.productionOrderId\"></anchor-lines-container>\n</template>\n";
// Exports
export default code;